import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button";
import React, { useContext } from "react";
import { makeStyles } from "tss-react/mui";
import blueHeaderSectionStyle from "assets/jss/xrs/views/sectionsSections/blueHeaderSectionStyle";
import Context from "../../../utils/context";
import Table from "components/Table/Table.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { NumericFormat } from "react-number-format";
import * as URLS from "../../../utils/XRSAPIs";
import { useDispatch, useSelector } from "react-redux";
const isMobile =
  /Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent) ||
  window.matchMedia("(max-width: 768px)").matches;

const useStyles = makeStyles()(() => blueHeaderSectionStyle);
export default function BlueHeaderSection(props) {
  const context = useContext(Context);
  const { classes } = useStyles();
  const [ballance, setBallance] = React.useState(0);
  const [site, setSite] = React.useState("");
  const token = sessionStorage.getItem("access_token");
  const [phone, setPhone] = React.useState("");
  const stateSite = useSelector((state) => state.SiteReducer.site);
  const stateSelectedAccount = useSelector(
    (state) => state.SelectedAccountsReducer.account
  );
  const currency = useSelector((state) => state.GetSiteDetailsReducer.currency);
  const deptphonenumber = useSelector(
    (state) => state.GetSiteDetailsReducer.deptphonenumber
  );
  const numOfAccounts = useSelector(
    (state) => state.AccountsReducer.numOfAccounts
  );
  const stateCustomer = useSelector((state) => state.CustomerReducer.customer);

  React.useEffect(() => {
    if (stateSelectedAccount == "NoAccount") {
      setBallance(stateCustomer.totalbalance);
    } else {
      setBallance(stateSelectedAccount.balance);
    }

    if (deptphonenumber != "") {
      setPhone(deptphonenumber);
    } else {
      setPhone(stateSite.phonenumber);
    }
  }, [stateSelectedAccount]);

  return (
    <Card className={classes.CardStyle}>
      <CardBody sx={{ padding: "0px" }}>
        <GridContainer>
          <GridItem xs={12} sm={4} md={4}>
            <h4 className={classes.white}>
              {" "}
              {numOfAccounts > 1 && stateSelectedAccount != "NoAccount"
                ? "Balance: "
                : "Total Balance: "}
              <NumericFormat
                value={ballance}
                displayType={"text"}
                fixedDecimalScale={true}
                thousandSeparator={true}
                decimalScale={2}
                prefix={currency}
              />
            </h4>
          </GridItem>

          <GridItem xs={12} sm={4} md={4}>
            {numOfAccounts > 1 && stateSelectedAccount != "NoAccount" ? (
              <h4 className={classes.whiteCenter}>
                {" " +
                  stateSelectedAccount.clientname +
                  ": " +
                  stateSelectedAccount.accountnumber}
              </h4>
            ) : null}
          </GridItem>
          <GridItem xs={12} sm={4} md={4}>
            <h4 className={classes.whiteRight}>
              Call us now:
              {isMobile ? (
                <a className={classes.whiteRight} href={"tel:" + phone}>
                  {phone}
                </a>
              ) : (
                <a className={classes.whiteRight}>{phone}</a>
              )}
            </h4>
          </GridItem>
        </GridContainer>
      </CardBody>
    </Card>
  );
}
